import { motion } from "framer-motion";
import { PenLine, Zap, MessageSquare, Gem } from "lucide-react";

const items = [
  { icon: PenLine, text: "Kleine Tattoos ab 80 €" },
  { icon: Zap, text: "Schnelle Terminvergabe" },
  { icon: MessageSquare, text: "Kostenlose Erstberatung" },
  { icon: Gem, text: "Piercing durch Spezialistin" },
];

export default function QuickInfoBar() {
  return (
    <section
      data-testid="quick-info-bar"
      className="bg-[#0A0A0A] border-y border-[#5A4A1A]/30"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4">
          {items.map((item, i) => (
            <motion.div
              key={i}
              className={`flex items-center gap-4 py-6 px-4 ${
                i < items.length - 1 ? "border-b lg:border-b-0 lg:border-r border-[#5A4A1A]/30" : ""
              } ${i % 2 === 0 && i < 2 ? "border-r lg:border-r border-[#5A4A1A]/30" : ""}`}
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.5 }}
            >
              <item.icon size={20} className="text-[#C9A84C] flex-shrink-0" />
              <span className="text-[#F0F0F0] text-sm font-outfit font-medium tracking-wide">
                {item.text}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
